<!-- Page Header End -->
<app-pageheader [pageOptions]="pageOptions"></app-pageheader>
<!-- Page Header End -->

<!-- Page content start -->
<div class="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
  <div class="container">
    <!-- Music content start -->
    <div id="MUSIC_SECTION">
      <h1 class="mb-4">{{ "music" | translate }}</h1>
      <app-articles-view
        [articles]="musicArticlesArray"
        [itemsPerPage]="musicLimit"
        [totalcount] ="musicTotalcount"
        [articleSection] = "'MUSIC_SECTION'"
        (onPaginateEvent) = "onMusicPaginateEvent($event)"
      ></app-articles-view>
    </div>
    <!-- Music content end -->

    <!-- Drawing content start -->
    <div id="DRAWING_SECTION">
      <h1 class="mb-4">{{ "drawing" | translate }}</h1>
      <app-articles-view
        [articles]="drawingArticlesArray"
        [itemsPerPage]="drawingLimit"
        [totalcount] ="drawingTotalcount"
        [articleSection] = "'DRAWING_SECTION'"
        (onPaginateEvent) = "onDrawingPaginateEvent($event)"
      ></app-articles-view>
    </div>
    <!-- Drawing content end -->
  </div>
</div>
<!-- Page content end -->
